namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmSablonaElektronickychPodpisu extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmSablonaElektronickychPodpisuReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmSablonaElektronickychPodpisuObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmSablonaElektronickychPodpisuObj());
            this.detailObj.createBase({
                contentName: "detailAdmSablonaElektronickychPodpisu",
                contentCaption: "jres:33000897", //RC 33000897 : Přiřazené fun. místo schv. roli EPK
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmSablonaElektronickychPodpisu", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
            this.detailObj.enableMdField(this.newRecord);
        }

        closing() {
            return this.detailObj.closeAction().done(() => { this.detailObj.removeTempFiles() });
        }
    }


    export class DetailAdmSablonaElektronickychPodpisuObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmSablonaElektronickychPodpisuReadDto> {
        private selectedTypePodpis: number; 
        private guidsFiles: string[];
        private srv: GContent
        private base64string: string;
        private newVersion: boolean;

        private getSrv(): GContent {
            if (this.srv == undefined || this.srv == null)
                this.srv = this.cnt.createServiceContent("Gordic.Adm.WebControls.DetailAdmSablonaElektronickychPodpisu");
            return this.srv;
        }

        create() {
            this.guidsFiles = [];
            this.base64string = "";
            
        }

        textPopis(): string | undefined | null {
            return `${this.data.nazev}`
        }

        setSxsDetail(): string {
            return `${this.data.ixs_dpo}`;
        }

        removeTempFiles() {
            this.getSrv().fire("RemoveTempFiles", { guids: this.guidsFiles });
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmSablonaElektronickychPodpisuSaveDto, close: boolean) {
            if (this.base64string != null && this.base64string != undefined)
                data.pozadi_viz_podp_txt = this.base64string;
            this.cnt.isl.AdmSablonaElektronickychPodpisu.upsert({ data: data }).get().then((output: any) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    });
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).catch((err) => {
                this.pendingAction("actSave", false)
                throw err;
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            this.openDetailOrModalWindow("Gordic.Adm.WebControls.DetailAdmSablonaElektronickychPodpisu", filterObj, dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmSablonaElektronickychPodpisu.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return `${this.options.contentCaption} - ${this.textPopis()}`
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actAddDuvod: {
                    icon: "fa-tag",
                    run: (ev, ctx) => {
                        this.addDuvod(ctx);
                    }
                },
                actAddText: {
                    icon: "fa-tag",
                    run: (ev, ctx) => {
                        this.addText(ctx);
                    }
                },
                actUploadImage: {
                    caption: "jres:33001014", //RC 33001014 : Nahrát obrázek
                    enabled: false,
                    icon: "fa-file-image-o",
                    run: (ev, ctx) => {
                        this.uploadImage();
                    }
                },
                actRemoveImage: {
                    caption: "jres:33001015", //RC 33001015 : Smazat obrázek
                    enabled: false,
                    icon: "gi-window-close",
                    run: (ev, ctx) => {
                        this.removeImage();
                    }
                }
            }
        }

        setEditMode(editMode: boolean) {
            this.cnt.findFields("viz_podpis").gfield(editMode == true ? "enable" : "disable");
            this.cnt.findFields("poz_viz_podp_pres").gfield(editMode == true ? "enable" : "disable");
            this.cnt.findFields("viz_podpis_new").gfield(editMode == true ? "enable" : "disable");
            this.cnt.actions.actUploadImage?.enabled(editMode);
            this.cnt.actions.actRemoveImage?.enabled(editMode);
            this.enableMdField(editMode);
        } 

        createForm() {
            let _this = this;
            this.form.form.layoutDescriptor = "L2M2S1";
            this.MakeSection("");
            this.MakeField("ixs_dpo", {
                flag: this.createFlagNemenne()
            });
            this.MakeField("nazev");
            this.MakeField("poznamka");
            this.MakeField("duvod_txt", {
                buttons: [this.getDuvodButtons()],
                verticalButtons: false
            })
            this.MakeSelectField("ktg_duv_podp", Gordic.Prefabs.Select.wflckdp(), { model: "model.ktg_duv_podp=value.ktg_duv_podp" })
            this.MakeSelectField("priz_znacka", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_znacka=value.priz_an" })
            this.MakeSelectField("priz_podpis", Gordic.Prefabs.Select.gincpan(), {
                model: "model.priz_podpis=value.priz_an",
                change: (ev, ctx) => {
                    if (!Array.isArray(ctx.value)) {
                        let field = this.cnt.findFields("priz_kvcrt");
                        if (ctx.value?.priz_an == 0) {
                            field.gfield("setValue", { priz_kvcrt: 0 }, false)
                            field.gfield("disable");
                        } else {
                            field.gfield("enable");
                        }
                    }
                    
                }
            })
            this.MakeSelectField("priz_kvcrt", Gordic.Prefabs.Select.admWflcpkv(), { model: "model.priz_kvcrt=value.priz_kvcrt" })
            this.MakeSelectField("typ_ltv", Gordic.Prefabs.Select.admWflcltv(), { model: "model.typ_ltv=value.typ_ltv" })
            this.MakeSelectField("priz_ts", Gordic.Prefabs.Select.admWflcpts(), { model: "model.priz_ts=value.priz_ts" })
            this.MakeSelectField("priz_edit_text", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_edit_text=value.priz_an" })
            this.MakeSelectField("ixs_cer_znacky", Gordic.Prefabs.Select.admWflscer(), {
                model: "model.ixs_cer_znacky=value.ixs_cer",
                serverFilters: {
                    aktivita: 100,
                    priz_int: 1,
                    pouze_platne: true
                }
            })
            this.MakeSection("");
            if (this.newVersion == true) {
                this.MakeSelectField("typ_viz_podpis", Gordic.Prefabs.Select.admWflctvp(), {
                    model: "model.typ_viz_podpis=value.typ_viz_podpis",
                    change: (ev, ctx) => {
                        if (!Array.isArray(ctx.value)) {
                            if (ctx.value) {
                                this.selectedTypePodpis = ctx.value.typ_viz_podpis ?? 0;
                                switch (this.selectedTypePodpis) {
                                    case 0:
                                        this.ShowField("viz_podpis");
                                        this.HideField("viz_podpis_new");
                                        this.HideField("pozadi_viz_podp");
                                        $("[data-row='row_pozadi_viz_podp_toolbox']").hide();
                                        break;
                                    case 10:
                                        this.HideField("viz_podpis");
                                        this.ShowField("viz_podpis_new");
                                        this.ShowField("pozadi_viz_podp");
                                        $("[data-row='row_pozadi_viz_podp_toolbox']").show();
                                        break;
                                }
                            }
                        }
                    }
                })
            }
            // Staré podpisy
            this.form.addRow({
                label: "jres:33000994",
                name: "row_viz_podpis"
            }).addField("gstringbox", {
                name: "viz_podpis",
                rows: 5,
                disabled: true,
                buttons: [this.getTextPolozky()],
                verticalButtons: false,
                model: function (op, dto, opt) {
                        switch (op) {
                            case "apply":
                                let data = dto.viz_podpis ? dto.viz_podpis.replaceAll('\\n', '\n') : "";
                                if (_this.selectedTypePodpis == 0) 
                                   $(this).gfield("setValue", data)
                                break;
                            case "collect":
                                if (_this.selectedTypePodpis == 0) 
                                    dto.viz_podpis = ($(this).gfield("getValue") ?? "").replaceAll('\n', '\\n');
                                break;
                    }
                }
            })
            if (this.newVersion == true) {
                // Nové podpisy
                this.form.addRow({
                    label: "jres:33000994",
                    name: "row_viz_podpis_new"
                }).addField("gmdfield", {
                    name: "viz_podpis_new",
                    disabled: true,
                    buttons: [this.getTextPolozky()],
                    verticalButtons: false,
                    rows: 5,
                    model: function (op, dto, opt) {
                        switch (op) {
                            case "apply":
                                if (_this.selectedTypePodpis == 10)
                                    $(this).gfield("setValue", dto.viz_podpis)
                                break;
                            case "collect":
                                if (_this.selectedTypePodpis == 10)
                                    dto.viz_podpis = $(this).gfield("getValue");
                                break;
                        }
                    }
                })
                this.form.addRow({
                    label: "jres:33001011", //RC 33001011 : Pozadí pro viz. podpis
                    name: "row_pozadi_viz_podp_toolbox"
                }).addField("gbuttonpanel", {
                    params: [
                        {
                            //enabled: false,
                            action: this.cnt.actions.actUploadImage
                        },
                        {
                            //enabled: 
                            action: this.cnt.actions.actRemoveImage
                        }
                    ]
                }).addRow({
                    label: "", //RC 33001011 : Pozadí pro viz. podpis
                    name: "row_pozadi_viz_podp"
                }).addField("gstaticfield", {
                    name: "pozadi_viz_podp",
                    model: function (op, dto, opt) {
                        switch (op) {
                            case "apply":
                                if (dto.pozadi_viz_podp_txt != null && dto.pozadi_viz_podp_txt != undefined)
                                    _this.setBackgroundImg(dto.pozadi_viz_podp_txt)
                                else
                                    _this.removeImage();
                                break;
                        }
                    }
                })
            }
            this.MakeSelectField("poz_viz_podp", Gordic.Prefabs.Select.admWflcpvp(), { model: "model.poz_viz_podp=value.poz_viz_podp" })
            this.form.addRow("jres:33000996").addField("gformbox", { //RC 33000996 : Pozice vizuálního podpisu
                name: "poz_viz_podp_pres",
                itemTemplate: "<b>jres:33000997:</b> {horizontal}<br /><b>jres:33000998:</b> {vertical}", //RC 33000998 : Vertikálně
                disabled: true,
                graphicInput: "oninput",
                itemEditable: (value) => {
                    return this.editMode
                },
                form: this.createFormVizPodpisPres(),
                newItemData: {
                    horizontal: 1,
                    vertical: 1
                },
                dialogOptions: {
                    width: 400,
                    height: 250
                },
                model: function (op, dto, opt) {
                    switch (op) {
                        case "apply":
                            if (dto.poz_viz_podp_pres) {
                                let data = dto.poz_viz_podp_pres.split(';')
                                $(this).gfield("setValue", { horizontal: data[0], vertical: data[1] })
                            }
                            break;
                        case "collect":
                            let resultData = $(this).gfield("getValue");
                            dto.poz_viz_podp_pres = resultData ? `${resultData['horizontal']};${resultData['vertical']}` : null;
                            break;
                    }
                }
            })
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }

        private createFormVizPodpisPres(): Gordic.Forms.Form {
            return new Gordic.Forms.Form()
                .addRow("jres:33000997").addField("gnumberbox", {
                    validators: [new Gordic.Validators.Required({ stopping: true }), new Gordic.Validators.Range({ stopping: true, min: 1 })],
                    name: "horizontal",
                    flag: "required"
                })
                .addRow("jres:33000998").addField("gnumberbox", {
                    validators: [new Gordic.Validators.Required({ stopping: true }), new Gordic.Validators.Range({ stopping: true, min: 1 })],
                    name: "horizontal",
                    flag: "vertical"
                })
        }

        private getDuvodButtons(): MenuParams {
            let polozky: { caption: string, tag: string }[] = [
                { caption: "jres:33000991", tag: "@(aktfun_ref)@" }, //RC 33000991 : Název referenta
                { caption: "jres:33000992", tag: "@(aktfun_fun)@" }, //RC 33000992 : Název funkce
                { caption: "jres:33000993", tag: "@(aktfun_nazev_rf)@" } //RC 33000993 : Název osoby a funkce
            ];
            let menu: MenuParams = {
                type: "static",
                icon: "fa-tag",
                children: []
            };
            polozky.forEach((item) => {
                if (menu.children)
                    menu.children.push({
                        action: this.cnt.actions.actAddDuvod,
                        caption: item.tag,
                        tooltip: item.caption,
                        actionContext: { tag: item.tag }
                    })
            })
            return menu;
        }

        private getTextPolozky(): MenuParams {
            let polozky: { caption: string, tag: string }[] = [
                { caption: "jres:33000999", tag: "@(nazev_cert)" }, //RC 33000999 : Název certifikátu - jednoduchý
                { caption: "jres:33001000", tag: "@(nazev_cert_ext)" }, //RC 33001000 : Název certifikátu - rozšířený
                { caption: "jres:33001001", tag: "@(nazev_autorita)" }, //RC 33001001 : Název certifikační autority
                { caption: "jres:33001002", tag: "@(nazev_fun)" }, //RC 33001002 : Název podepisující funkce
                { caption: "jres:33001003", tag: "@(nazev_ref)" }, //RC 33001003 : Název podepisujícího referenta
                { caption: "jres:33001004", tag: "@(nazev_org)" }, //RC 33001004 : Název organizace
                { caption: "jres:33001005", tag: "@(platnost_od)" }, //RC 33001005 : Platnost certifikátu od
                { caption: "jres:33001006", tag: "@(platnost_do)" }, //RC 33001006 : Platnost certifikátu do
                { caption: "jres:33001007", tag: "@(datum_podp)" }, //RC 33001007 : Datum podpisu (bez času)
                { caption: "jres:33001008", tag: "@(cas_podp)" }, //RC 33001008 : Datum podpisu (včetně času)
                { caption: "jres:33001009", tag: "@(nazev_orj)" }, //RC 33001009 : Název organizační jednotky
                { caption: "jres:33001010", tag: "@(nazev_rf)" }, //RC 33001010 : Název funkce, včetně zástupu
            ];
            let menu: MenuParams = {
                type: "static", 
                icon: "fa-tag",
                children: []
            }
            polozky.forEach((item) => {
                menu.children?.push({
                    action: this.cnt.actions.actAddText,
                    caption: item.tag,
                    tooltip: item.caption,
                    actionContext: { tag: item.tag}
                })
            })
            return menu;
        }

        private addDuvod(ctx: any) {
            let field = this.cnt.findFields("duvod_txt")
            let fieldData = field.gfield("getValue");
            if (ctx.tag) {
                fieldData += ctx.tag
                field.gfield("setValue", fieldData);
            }
        }

        private addText(ctx: any) {
            let field = this.cnt.findFields(this.selectedTypePodpis == 10 ? "viz_podpis_new" : "viz_podpis")
            let fieldData = field.gfield("getValue");
            if (ctx.tag) {
                fieldData += ctx.tag
                field.gfield("setValue", fieldData);
            }
        }

        private uploadImage() {
            let form = new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1" })
                .addRow("jres:33001012").addField("gfilefield", { //RC 33001012 : Nový obrázek
                    name: "img",
                    acceptExtension: ".png",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    fileUploaded: (ev, ctx) => {
                        if (ctx.fileInfo)
                            if (ctx.fileInfo.guid)
                                this.guidsFiles.push(ctx.fileInfo.guid)
                    }
                }) 

            this.cnt.dialogs.simpleForm("jres:33001013", form, null, { //RC 33001013 : Nové pozadí šablony el. podpisu
                width: 400,
                height: 250
            }).on("ok", (ev, ctx) => {
                if (ctx.img) {
                    if (Array.isArray(ctx.img)) {
                        if (ctx.img.length) {
                            if (ctx.img[0].guid) {
                                this.getSrv().call("GetImageToBase64", { guid: ctx.img[0].guid }).then((o) => {
                                    this.setBackgroundImg(o);
                                })
                            }
                        }
                    }
                }
            })
        }

        private setBackgroundImg(base64img: string) {
            this.base64string = base64img;
            $("[data-field='pozadi_viz_podp']").find('.gform-text').empty().append($(`<img style='height: 150px' src='data:image/png;base64, ${base64img} ' alt='Pozadi pro vizualni podpis' />`))
        }

        private removeImage() {
            this.base64string = "";
            $("[data-field='pozadi_viz_podp']").find('.gform-text').empty().append($("<span>").text("jres:33001016")) //RC 33001016 : Není vybrán žádný obrázek.
        }

        enableMdField(newRecord: boolean) {
            if (this.newVersion) {
                this.cnt.findFields("viz_podpis_new").find(".gbuttonpanel").gbuttonpanel("option", "params").forEach(item => {
                    if (item.type == "static")
                        item.children?.forEach(subItem => {
                            if (subItem.type == "action")
                                subItem.action?.enabled(newRecord);
                        })
                    if (item.type == 'action')
                        item.action?.enabled(newRecord);
                })
            }
        }
    }
}
